<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-l">
		<wa-button [routerLink]="['/frameworks/web-awesome-pro']" appearance="plain" variant="neutral">&larr; Back to Web Awesome Pro</wa-button>
		<div class="wa-cluster" style="align-items:center;justify-content:space-between;">
			<h1 waHeading="xl" waText>WaIconFA</h1>
			<a href="javascript:void(0)" onclick="document.getElementById('examples-section')?.scrollIntoView({behavior:'smooth'})" style="color:var(--wa-color-brand-normal);cursor:pointer;font-size:var(--wa-font-size-s);white-space:nowrap;">Examples ↓</a>
		</div>
		<p waBody="m" waColorText="quiet" waText>Font Awesome icon with Pro styling integration. Extends WaIcon and accepts FontAwesome Pro icon enums, families &#40;Solid, Regular, Light, Thin, Duotone&#41;, and variants.</p>
		<wa-details appearance="outlined" summary="Import, Interfaces & Constructors">
			<div class="wa-stack wa-gap-m">
				<div waCaption="s" waFontWeight="semibold" waText>IMPORT</div>
				<markdown [data]="mdContent_351" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<div waCaption="s" waFontWeight="semibold" waText>IMPLEMENTS</div>
				<div class="wa-cluster wa-gap-xs">
					<wa-tag pill variant="neutral">All WaIcon capabilities &mdash; name, family, variant, src, label, fixed-width, duotone coloring</wa-tag>
				</div>
				<div waCaption="s" waFontWeight="semibold" waText>CONSTRUCTORS</div>
				<markdown [data]="mdContent_352" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<p waBody="s" waColorText="quiet" waText>Creates an empty WaIconFA element</p>
				<markdown [data]="mdContent_353" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<p waBody="s" waColorText="quiet" waText>Creates an icon from a FA icon enum</p>
				<markdown [data]="mdContent_354" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<p waBody="s" waColorText="quiet" waText>Creates an icon with specific family</p>
				<markdown [data]="mdContent_355" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<p waBody="s" waColorText="quiet" waText>Creates an icon with name, family, and variant</p>
			</div>
		</wa-details>
		<div class="wa-stack wa-gap-m" id="examples-section">
			<h2 waHeading="l" waText>Examples</h2>
			<div class="wa-stack wa-gap-xs">
				<h4 waHeading="s" waText>Pro Solid Icon</h4>
				<p waBody="s" waColorText="quiet" waText>Create a solid FA Pro icon.</p>
				<markdown [data]="mdContent_356" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
			</div>
			<div class="wa-stack wa-gap-xs">
				<h4 waHeading="s" waText>Pro Light Icon</h4>
				<p waBody="s" waColorText="quiet" waText>Create a light-weight icon.</p>
				<markdown [data]="mdContent_357" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
			</div>
			<div class="wa-stack wa-gap-xs">
				<h4 waHeading="s" waText>Icon with Family and Variant</h4>
				<p waBody="s" waColorText="quiet" waText>Specify family and variant explicitly.</p>
				<markdown [data]="mdContent_358" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
			</div>
		</div>
	</div>
</div>